module.exports = __webpack_public_path__ + "media/images/common/arrow-6a6b0aafb02a5493a80338b47cb890a8.svg";